







































































































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import WorkItemForm from '@/views/work-item/work-item-form.component.vue';
import FilterFields from '@/domain/project/filter-fields.entity';
import ButtonComponent from '@/shared/button/button.component.vue';
import WorkItemModalState from '@/domain/work-item/work-item-modal-state.entity';
import VstsIntegrationBlockedIconComponent from './vsts-integration-blocked-icon.component.vue';

@Component({
  components: {
    WorkItemForm,
    ButtonComponent,
    VstsIntegrationBlockedIconComponent,
  },
})
export default class WorkItemModal extends Vue {
  @Prop() workItem!: any;

  @Prop() type!: string;

  @Prop() filterFields!: FilterFields;

  @Prop() parentWorkItems!: any;

  @Prop() workItemAction!: any;

  @Prop() modalFields!: WorkItemModalState;

  @Prop() saveWorkItemLoading!: Boolean;

  @Prop({ default: () => [] }) projectDirectives!: any[];

  @Prop(Boolean) dialog!: boolean;

  @Prop({ type: Boolean, default: false }) autoFill!: boolean;

  private dialogModal: boolean = false;

  blockSaveButton: boolean = false;

  validForm: boolean = true;

  saveWorkItem(event: any, close: boolean) {
    this.blockSaveButton = true;
    this.$emit('saveWorkItem', event, close);
  }

  cancel() {
    if (this.modalFields.buttonCancel === false) {
      this.dialogModal = !this.dialogModal;
    } else {
      this.close();
    }
  }

  close() {
    this.dialogModal = false;
    this.$emit('close');
  }

  @Watch('saveWorkItemLoading')
  updateBlockButtonFlag() {
    if (!this.saveWorkItemLoading) {
      this.blockSaveButton = false;
    }
  }

  save() {
    if (this.modalFields.buttonSave === false) {
      const { workItemForm }: any = this.$refs;
      workItemForm.save();
    }
  }

  resetValidation(): void {
    const { workItemForm }: any = this.$refs;
    workItemForm.resetValidation();
  }

  updateValidForm(validForm: boolean): void {
    this.validForm = validForm;
  }
}
